import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';

import { HttpCacheService } from '@app-core/services/cache/cache.service';
import { getApisToCache } from '@app-core/constants/constants';

import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class CacheInterceptorService implements HttpInterceptor {
  constructor(private _cache: HttpCacheService) {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const { url = '', method = '' } = req || {};

    if (method === 'GET') {
      // Lazy evaluation of APIs to cache
      const apisToCache = getApisToCache();
      const cacheConfig = apisToCache.find((api: any) => url.includes(api.url));

      if (cacheConfig) {
        const cache = this._cache.getCache(req) || null;
        if (cache) {
          return of(cache);
        }

        return next.handle(req).pipe(
          tap((event) => {
            if (event instanceof HttpResponse) {
              this._cache.setCache(req, event, cacheConfig.expiry);
            }
          })
        );
      }
    }

    return next.handle(req);
  }
}
